import { Chevron } from "@components/icons"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { smallcapsBold14Styles } from "@constants/typography"
import React from "react"
import styled from "styled-components"

const Container = styled.button`
  z-index: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  display: flex;
  width: 100%;
  height: 72px;
  padding: 0 20px;
  outline: none;
  border: none;
  border-bottom: 1px solid ${colors.dividerLineGray};
  background-color: ${colors.offWhite};

  &:focus,
  &:active {
    outline: none;
  }

  @media ${breakpoints.tablet} {
    padding: 0 32px;
  }
`

const Text = styled.div`
  ${smallcapsBold14Styles}
  flex-grow: 1;
  padding-top: 4px;
  padding-left: 2px;
  text-align: left;
`

const IconWrapper = styled.div`
  flex-direction: row;
  align-items: center;
  display: flex;
  transform: translateX(-8px) rotate(180deg);
  width: 24px;
  height: 24px;
  margin-right: 4px;
`

interface BackButtonProps {
  onRequestClose: () => void
  text: string
}

const BackButton: React.FC<BackButtonProps> = ({ onRequestClose, text }) => {
  return (
    <Container onClick={onRequestClose}>
      <IconWrapper>
        <Chevron />
      </IconWrapper>
      <Text>{text}</Text>
    </Container>
  )
}

export default BackButton
